import { callApi } from "repoV2/utils/common/api/callApi";
import { CALL_API_METHODS } from "repoV2/constants/apis";
import { getQueryParam } from "repoV2/utils/urls&routing/urlParams";
import { URL_SEARCH_PARAMS } from "repoV2/features/Common/modules/URLsNRouting/URLsNRouting.constants";
import { checkIsStringEmpty } from "repoV2/utils/common/dataTypes/string";
import { coupon_code_apis } from "./CouponCode.constants";

export const callApplyCouponCodeOnListing = (data: {
    code: string; // coupon code
    listingUuid: string; // listing uuid on which the "code" is applied
    currencyName: string; // name of the currency ("INR", "USD", etc)
    isUpsellOrder?: boolean; // whether upsell listings are present while applying the coupon code or not
    discountCodeType?: string;
    customerEmail?: string; // customer email... needed when discount code type is loyalty
    appliedCount?: number; // count of number of times the code is applied... used in cart flow, as we allow adding coupon codes per listing
}) => {
    const dynamicLink = getQueryParam(URL_SEARCH_PARAMS.DYNAMIC_LINK);
    return callApi({
        url: coupon_code_apis.apply_code_on_listing,
        data: {
            code: data.code,
            applied_count: data.appliedCount,
            listing_uuid: data.listingUuid,
            currency: data.currencyName,
            is_upsell_order: data.isUpsellOrder,
            customer_email: data.customerEmail,
            discountCodeType: data.discountCodeType,
            ...(!checkIsStringEmpty(dynamicLink) && {
                dynamic_link: dynamicLink,
            }),
        },
        method: CALL_API_METHODS.POST,
        extraOptions: { appendExlyBackendHeaders: true },
    });
};
